import type { Branch, Honbu } from './types';

// MOCK [#239]: 本番実装時はバックエンドから取得した拠点・広告コード一覧で置き換える。
// 広告コードの値は各 event-handler の advertisement-resolver が RPM 登録に用いているものと同一。
export const BRANCHES_BY_HONBU: Record<Honbu, readonly Branch[]> = {
  '1honbu': [
    {
      code: '1honbu-tokyo',
      label: '東京拠点',
      canForwardToTokyo: false,
      advertisements: ['バイトル東京モバイル', 'バイトル東京オフィス', 'airwork東京モバイル', '東京/オフィス/airwork'],
    },
    {
      code: '1honbu-osaka',
      label: '大阪拠点',
      canForwardToTokyo: true,
      // 大阪は広告コードと媒体コードが同値（東京は広告コード "バイトル東京モバイル" に対し媒体コードが
      // "東京/モバイル/バイトルドットコム" と別値）。媒体コードは画面非公開のため backend 結線時に投入する。
      advertisements: ['大阪/モバイル/バイトルドットコム', '大阪/オフィス/バイトルドットコム'],
    },
  ],
  '2honbu': [
    {
      code: '2honbu-tokyo',
      label: '東京拠点',
      canForwardToTokyo: false,
      advertisements: ['東京/営業2本部/バイトル', '東京/営業2本部/AirWork(ﾄﾘﾌﾟﾙ2)'],
    },
    {
      code: '2honbu-osaka',
      label: '大阪拠点',
      canForwardToTokyo: true,
      advertisements: ['大阪/営業2本部/バイトルドットコム'],
    },
  ],
};
